import consts from "@/consts"
import {getApiProps} from "@/lib/lib";
import range from "lodash/range";
// import {objectComparison} from "@/lib/lib";
const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed_at';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

let _xRoutesCalculatedIndexCache = {arr: null, map: null}
function getXRoutesCalculatedIndexMap(state) {
    if (_xRoutesCalculatedIndexCache.arr !== state.xRoutesCalculated) {
        _xRoutesCalculatedIndexCache.map = new Map(state.xRoutesCalculated.map((u, i) => [u.id, i]))
        _xRoutesCalculatedIndexCache.arr = state.xRoutesCalculated
    }
    return _xRoutesCalculatedIndexCache.map
}

export default {
    state: {
        xRoutesCalculatedLiteLoad: false,
        xRoutesCalculatedFullLoad: false,
        xRoutesCalculated: [],
    },
    actions: {
        fetchXRoutesCalculated/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchXRoutesCalculated', args, time: Date.now() / 1000})

                const params = getApiProps('xRoutesCalculated', args)
                delete params.routeId
                this.$api.xroutesCalculated.getAll(args?.routeId, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchXRoutesCalculated', args, inprogress: false})
                    });
            })
        },
        fetchXRoutesCalculatedByRoute({commit}, args) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutesCalculated', args)
                delete params?.routeId;
                this.$api.xroutesCalculated.getAll(args?.routeId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('updateXRoutesCalculated', response.data)

                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
            })
        },
        fetchXRoutesCalculatedAll({dispatch, commit}) {
            new Promise((resolve, reject) => {
                this.$api.xroutesCalculated.getAll()
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('setXRoutesCalculated', response.data)
                            commit('setXRoutesCalculatedLiteLoad', true)
                            commit('setXRoutesCalculatedFullLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchXRoutesCalculatedAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchXRoutesCalculatedAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isXRoutesCalculatedLiteLoad) {
                    return resolve(getters.getXRoutesCalculated.length)
                }
                dispatch('fetchXRoutesCalculated', {lite: true})
                    .then((data) => {
                        commit('updateXRoutesCalculated', data)
                        //commit('setXRoutesCalculatedLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchXRoutesCalculatedAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchXRoutesCalculatedAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchXRoutesCalculatedAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchXRoutesCalculatedChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getXRoutesCalculated.length) {
                        return resolve([])
                    }
                    let pageSize = consts.querySettings.pageSize
                    let pages = Math.ceil(getters.getXRoutesCalculated.length / pageSize)
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchXRoutesCalculated', {page, 'page-size': pageSize, ...args})
                            .then((data) => {
                                commit('updateXRoutesCalculated', data)
                            })
                            .catch(() => {
                                dispatch('fetchXRoutesCalculated', {page, 'page-size': pageSize, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setXRoutesCalculatedFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchXRoutesCalculatedAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchXRoutesCalculatedChanged', args, inprogress: false})
                })
        },
        fetchXRoutesCalculatedChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isXRoutesCalculatedFullLoad) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchXRoutesCalculatedChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchXRoutesCalculated', args)
                .then((data) => {
                    commit('updateXRoutesCalculated', data)
                    return dispatch('fetchXRoutesCalculated', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterXRoutesCalculated', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchXRoutesCalculatedChanged', args, inprogress: false})
                });
        },
        reloadXRoutesCalculatedAll({commit, dispatch}, args) {
            commit('clearXRoutesCalculated')
            return dispatch('fetchXRoutesCalculatedAll', args)
                // .then(() => {
                //     dispatch('fetchXRoutesCalculatedAllPages', args)
                // })
        },

        fetchXRouteCalculated({commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.id) {
                    return reject(false)
                }
                const params = getApiProps('xRoutesCalculated', args)
                delete params.id;
                this.$api.xroutesCalculated.find(args.id, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateXRouteCalculated', response.data)
                            resolve(true)
                        } else {
                            console.error(response);
                            reject(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(false)
                    });
            });
        },

        saveXRouteCalculated({dispatch}, xRouteCalculated) {
            let fn = (xRouteCalculated.id) ? 'updateXRouteCalculated' : 'createXRouteCalculated'
            return dispatch(fn, xRouteCalculated);
        },
        createXRouteCalculated({commit, dispatch}, xRouteCalculated) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutesCalculated')
                this.$api.xroutesCalculated.create(xRouteCalculated, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateXRouteCalculated', response.data)
                            dispatch('fetchXRoutesCalculatedChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateXRouteCalculated({commit, dispatch}, xRouteCalculated) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutesCalculated')
                this.$api.xroutesCalculated.update(xRouteCalculated.id, xRouteCalculated, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateXRouteCalculated', response.data)
                            dispatch('fetchXRoutesCalculatedChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        deleteXRouteCalculated({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutesCalculated')
                this.$api.xroutesCalculated.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            if (!response.data) commit('deleteXRouteCalculated', id)
                            else commit('updateXRouteCalculated', response.data)
                            dispatch('fetchXRoutesCalculatedChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        restoreXRouteCalculated({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutesCalculated')
                this.$api.xroutesCalculated.restore(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateXRouteCalculated', response.data)
                            dispatch('fetchXRoutesCalculatedChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteXRouteCalculatedPermanently({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutesCalculated')
                this.$api.xroutesCalculated.deletePermanently(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            commit('deleteXRouteCalculated', id)
                            dispatch('fetchXRoutesCalculatedChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        //sayHello() {}
    },
    mutations: {
        setXRoutesCalculatedLiteLoad(state, LiteLoad) {
            state.xRoutesCalculatedLiteLoad = state.xRoutesCalculatedLiteLoad || LiteLoad
        },
        setXRoutesCalculatedFullLoad(state, FullLoad) {
            state.xRoutesCalculatedFullLoad = state.xRoutesCalculatedFullLoad || FullLoad
        },

        setXRoutesCalculated(state, nXRoutesCalculated) {
            nXRoutesCalculated = nXRoutesCalculated.map(u => {
                //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                return Object.freeze(u)
            })
            nXRoutesCalculated.sort(sortByName)
            state.xRoutesCalculated = nXRoutesCalculated
        },

        updateXRoutesCalculated(state, nXRoutesCalculated) {
            if (!state.xRoutesCalculated.length) {
                nXRoutesCalculated = nXRoutesCalculated.map(u => {
                    //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return Object.freeze(u)
                })
                nXRoutesCalculated.sort(sortByName)
                state.xRoutesCalculated = nXRoutesCalculated
                return true
            }

            // console.log('updateXRoutesCalculated', state.xRoutesCalculated.length)
            const indexById = getXRoutesCalculatedIndexMap(state)
            nXRoutesCalculated.forEach(function (nXRouteCalculated) {
                let i = indexById.has(nXRouteCalculated.id) ? indexById.get(nXRouteCalculated.id) : -1
                if (i < 0) {
                    indexById.set(nXRouteCalculated.id, state.xRoutesCalculated.length)
                    state.xRoutesCalculated.push(Object.freeze(nXRouteCalculated))
                } else
                if (state.xRoutesCalculated[i][changedField] != nXRouteCalculated[changedField]) {
                    // updateObjectByDiff(state.xRoutesCalculated[i], nXRouteCalculated)
                    delete nXRouteCalculated.id
                    state.xRoutesCalculated[i] = Object.freeze({...state.xRoutesCalculated[i], ...nXRouteCalculated})
                }
            })
        },
        filterXRoutesCalculated(state, nXRoutesCalculated) {
            // let Ids = state.xRoutesCalculated.map(u=> u.id)
            let nIds = new Set(nXRoutesCalculated.map(u => u.id))
            state.xRoutesCalculated = state.xRoutesCalculated.filter(u => nIds.has(u.id))
        },
        updateXRouteCalculated(state, nXRouteCalculated) {
            let i = state.xRoutesCalculated.findIndex(u => (u.id == nXRouteCalculated.id))
            if (i < 0) {
                state.xRoutesCalculated.push(Object.freeze(nXRouteCalculated))
            } else
            if (!state.xRoutesCalculatedFullLoad || state.xRoutesCalculated[i][changedField] != nXRouteCalculated[changedField]) {
                // updateObjectByDiff(state.xRoutesCalculated[i], nXRouteCalculated)
                let xRouteCalculated = {...nXRouteCalculated} //ToDo fix
                delete xRouteCalculated.id
                state.xRoutesCalculated[i] = Object.freeze({...state.xRoutesCalculated[i], ...xRouteCalculated})
            }
        },
        deleteXRouteCalculated(state, id) {
            let i = state.xRoutesCalculated.findIndex(u => (u.id == id))
            if (i != -1) {
                state.xRoutesCalculated.splice(i, 1)
            }
        },
        clearXRoutesCalculated(state) {
            state.xRoutesCalculated = []
            state.xRoutesCalculatedLiteLoad = false
            state.xRoutesCalculatedFullLoad = false
        },
    },
    getters: {
        isXRoutesCalculatedLiteLoad(state) {
            return state.xRoutesCalculatedLiteLoad
        },
        isXRoutesCalculatedFullLoad(state) {
            return state.xRoutesCalculatedFullLoad
        },
        getXRoutesCalculated(state) {
            return state.xRoutesCalculated
        },
        getXRoutesCalculatedByRouteId(state) {
            return state.xRoutesCalculated.reduce((out, cr) => {
                if(!out[cr.route_id]?.length) out[cr.route_id] = []
                out[cr.route_id].push(cr)
                return out
            }, {})
        },
        getXRoutesCalculatedByIds(state) {
            return state.xRoutesCalculated.reduce((xRoutesCalculatedByIds, u) => {
                xRoutesCalculatedByIds[u.id] = u
                return xRoutesCalculatedByIds
            }, {})
        },
    }
}
